module.exports = require('./dist');


//////////////////
// WEBPACK FOOTER
// ./~/vue-croppie/index.js
// module id = ujXI
// module chunks = 1